import LoadingSpinner from "./LoadingSpinner";

export default function LoadingSpinnerWrapper({ classes }) {
  return (
    <div className="flex items-center justify-center w-full h-full md:min-h-1 min-h-[400px]">
      <LoadingSpinner classes={classes} />
    </div>
  );
}
